import unset from 'lodash/unset';

export const clearSensitiveData = (telemetry: unknown) => {
  unset(telemetry, 'data.url');
  unset(telemetry, 'data.errorSrc');
};
